/**
 * Mirrors the permission/role slugs seeded in database/vynzo_schema.sql
 * (+ banners.manage from migration 0004_banners.sql). Kept as a single
 * source of truth so a typo here fails at compile time instead of
 * silently hiding a sidebar item or button at runtime.
 */
export const PERMISSIONS = {
  USERS_VIEW: 'users.view',
  USERS_MANAGE: 'users.manage',
  ROLES_MANAGE: 'roles.manage',
  MOVIES_VIEW: 'movies.view',
  MOVIES_MANAGE: 'movies.manage',
  SERIES_VIEW: 'series.view',
  SERIES_MANAGE: 'series.manage',
  TAXONOMY_MANAGE: 'taxonomy.manage',
  PLANS_VIEW: 'plans.view',
  PLANS_MANAGE: 'plans.manage',
  SUBSCRIPTIONS_VIEW: 'subscriptions.view',
  SUBSCRIPTIONS_MANAGE: 'subscriptions.manage',
  PAYMENTS_VIEW: 'payments.view',
  PAYMENTS_MANAGE: 'payments.manage',
  REPORTS_VIEW: 'reports.view',
  SETTINGS_MANAGE: 'settings.manage',
  LOGS_VIEW: 'logs.view',
  NOTIFICATIONS_MANAGE: 'notifications.manage',
  BANNERS_MANAGE: 'banners.manage',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const ROLES = {
  SUPER_ADMIN: 'super-admin',
  CONTENT_MANAGER: 'content-manager',
  SUPPORT_AGENT: 'support-agent',
  FINANCE_MANAGER: 'finance-manager',
  SUBSCRIBER: 'subscriber',
} as const;

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const PUBLISH_STATUSES = ['draft', 'published', 'archived'] as const;
export const AGE_RATINGS = ['U', 'U/A', 'A', 'S', '7+', '13+', '16+', '18+'] as const;
export const QUALITIES = ['SD', 'HD', 'FHD', '4K'] as const;
export const BILLING_CYCLES = ['monthly', 'quarterly', 'half_yearly', 'yearly', 'lifetime'] as const;
export const SUBSCRIPTION_STATUSES = ['trial', 'active', 'expired', 'cancelled', 'pending'] as const;
export const PAYMENT_STATUSES = ['pending', 'success', 'failed', 'refunded'] as const;
export const NOTIFICATION_TYPES = ['system', 'promo', 'content', 'billing', 'security'] as const;
